import { useLang } from "../i18n/LanguageContext";
import { IMAGES } from "../lib/restaurant";

export default function LanguageModal() {
  const { setLang, needsSelection } = useLang();
  if (!needsSelection) return null;

  const options = [
    { code: "pl", label: "Polski",   flag: "🇵🇱" },
    { code: "en", label: "English",  flag: "🇬🇧" },
    { code: "it", label: "Italiano", flag: "🇮🇹" },
    { code: "de", label: "Deutsch",  flag: "🇩🇪" },
  ];

  return (
    <div
      data-testid="language-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-charcoal/85 backdrop-blur-md animate-fade-up"
    >
      <div className="absolute inset-0" style={{
        backgroundImage: `url(${IMAGES.heroEvening})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        opacity: 0.15,
      }} />
      <div className="relative bg-charcoal border border-gold/30 max-w-md w-[92%] sm:w-full mx-auto p-8 sm:p-10 text-center text-cream shadow-2xl">
        <img src={IMAGES.logo} alt="Segreto" className="h-20 w-20 rounded-full object-cover mx-auto mb-5 ring-1 ring-gold/40" />
        <p className="uppercase-track text-[10px] text-gold mb-3">Segreto · Katowice</p>
        <h2 className="font-serif text-2xl sm:text-3xl mb-1">Wybierz język</h2>
        <p className="font-serif italic text-lg text-cream/85 mb-1">Choose your preferred language</p>
        <p className="font-serif italic text-base text-cream/70 mb-1">Scegli la lingua</p>
        <p className="font-serif italic text-base text-cream/70 mb-6">Sprache auswählen</p>
        <div className="space-y-3">
          {options.map((o) => (
            <button
              key={o.code}
              data-testid={`modal-lang-${o.code}`}
              onClick={() => setLang(o.code)}
              className="group w-full h-12 px-6 border border-cream/25 hover:bg-gold hover:border-gold hover:text-charcoal text-cream uppercase-track text-xs transition-all duration-300 flex items-center justify-center gap-3"
            >
              <span className="text-base leading-none">{o.flag}</span>
              <span>{o.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
